import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { Paper, List } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {
    ListItem, ListItemAvatar,
    ListItemText, Avatar,
    Divider,
} from '@mui/material';
import {
    selectedAssetIdEventsSelector, visibleEventsSelector
} from '../../features/events/eventsSlice';

import EventListItem from './EventListItem';

const EventListView = () => {
    const visibleEvents = useSelector(visibleEventsSelector);
    const eventsForAssetId = useSelector(selectedAssetIdEventsSelector);
    const eventLoading = useSelector(state => state.events.loading);
    const eventLoaded = useSelector(state => state.events.loadComplete);


    const tickbuild = () => {
        let eventlist = [];
        if (visibleEvents) {
            if (visibleEvents.length > 0) {
                visibleEvents.forEach((eventId, index) => {
                    eventlist.push(
                        <Fragment key={eventId}>
                            <EventListItem
                                eventId={eventId}
                                index={index}
                                eventForAssetID={eventsForAssetId}
                            />
                            {index < visibleEvents.length - 1 && <Divider />}

                        </Fragment>
                    );
                });
            }
        }

        if (eventlist.length === 0) {
            eventlist.push(
                <ListItem key="noevent">
                    <ListItemAvatar>
                        <Avatar style={{ backgroundColor: 'Crimson' }}>
                            0
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="No Events Found" />

                </ListItem>
            );
        }
        return eventlist;
    }

    return (
        <div>
            <Paper elevation={3}>
                {
                    eventLoading && !eventLoaded &&
                    <ListItem key="noevent">
                        <ListItemAvatar>
                            <Avatar style={{ backgroundColor: 'White' }}>
                                <CircularProgress color="secondary" />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Loading Events... " />

                    </ListItem>

                }
                {
                    eventLoaded && !eventLoading && <List dense>{tickbuild()}</List>
                }


            </Paper>
        </div>
    );
}

export default React.memo(EventListView);